import { render, staticRenderFns } from "./relatorio-dispendio-rda.vue?vue&type=template&id=57038f97&scoped=true&"
import script from "./relatorio-dispendio-rda.vue?vue&type=script&lang=js&"
export * from "./relatorio-dispendio-rda.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-dispendio-rda.vue?vue&type=style&index=0&id=57038f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57038f97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VCardTitle,VCarousel,VCarouselItem,VDataTable,VIcon,VPagination,VSwitch})
